// extracted by mini-css-extract-plugin
export default {"container":"AdminActionsPage_container__cXShA","card":"AdminActionsPage_card__hojsh","cardImg":"AdminActionsPage_cardImg__Yzy1z"};